module.exports = __webpack_public_path__ + "static/media/bf13.4a240663.png";